import {
  ClipboardPlus,
  FlaskConical,
  Pill,
  Scan,
  Stethoscope,
} from "lucide-react";

/** Chip order on the new-case form. */
export const CASE_SCENARIOS = [
  {
    id: "lab_results",
    icon: FlaskConical,
    chipKey: "scenario.lab_results.chip",
    nameKey: "scenario.lab_results.name",
    runKey: "scenario.lab_results.run",
    descriptionKey: "scenario.lab_results.description",
    attachKey: "scenario.lab_results.attach",
  },
  {
    id: "imaging",
    icon: Scan,
    chipKey: "scenario.imaging.chip",
    nameKey: "scenario.imaging.name",
    runKey: "scenario.imaging.run",
    descriptionKey: "scenario.imaging.description",
    attachKey: "scenario.imaging.attach",
  },
  {
    id: "treatment_plan",
    icon: ClipboardPlus,
    chipKey: "scenario.treatment_plan.chip",
    nameKey: "scenario.treatment_plan.name",
    runKey: "scenario.treatment_plan.run",
    descriptionKey: "scenario.treatment_plan.description",
    attachKey: "scenario.treatment_plan.attach",
  },
  {
    id: "diagnosis",
    icon: Stethoscope,
    chipKey: "scenario.diagnosis.chip",
    nameKey: "scenario.diagnosis.name",
    runKey: "scenario.diagnosis.run",
    descriptionKey: "scenario.diagnosis.description",
    attachKey: "scenario.diagnosis.attach",
  },
  {
    id: "medications",
    icon: Pill,
    chipKey: "scenario.medications.chip",
    nameKey: "scenario.medications.name",
    runKey: "scenario.medications.run",
    descriptionKey: "scenario.medications.description",
    attachKey: "scenario.medications.attach",
  },
];

export const CASE_SCENARIO_IDS = CASE_SCENARIOS.map((item) => item.id);

export const SCENARIO_I18N_KEYS = [
  "scenario.groupLabel",
  "scenario.caption",
  "scenario.askWithoutFile",
  "scenario.attach.takePhoto",
  "scenario.attach.choosePhotos",
  "scenario.attach.chooseFiles",
  "scenario.attach.camera",
  "scenario.summaryLabel",
  ...CASE_SCENARIOS.flatMap((item) => [
    item.chipKey,
    item.nameKey,
    item.runKey,
    item.descriptionKey,
    item.attachKey,
  ]),
];

export function caseScenarioById(id) {
  return CASE_SCENARIOS.find((item) => item.id === id) || null;
}

export function isCaseScenarioId(value) {
  return typeof value === "string" && CASE_SCENARIO_IDS.includes(value);
}

/**
 * Read a scenario from handleSubmit's argument.
 * A click handler passes a DOM or React event, which is not a scenario.
 */
export function scenarioFromSubmitArg(options) {
  if (!options || typeof options !== "object") {
    return { scenario: null, alreadyTracked: false };
  }
  if (
    typeof options.preventDefault === "function"
    || Object.prototype.hasOwnProperty.call(options, "nativeEvent")
  ) {
    return { scenario: null, alreadyTracked: false };
  }
  return {
    scenario: isCaseScenarioId(options.scenario) ? options.scenario : null,
    alreadyTracked: options.alreadyTracked === true,
  };
}
